/**
 * HomeARHomeComposeDemoView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait HomeARHomeComposeDemo
 */

import { useHomeARHomeComposeDemoLogic } from '@/hooks/traits/useHomeARHomeComposeDemoLogic';
import type { HomeARHomeComposeDemoConfig } from '@/hooks/traits/useHomeARHomeComposeDemoLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { HomeARDemoComposeTask } from '@app/shared';
import { HomeARDemoComposeEquationView } from '@/components/traits/HomeARDemoComposeEquationView';
import { Split } from '@almadar/ui/components';
import { HomeARDemoComposeTourView } from '@/components/traits/HomeARDemoComposeTourView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface HomeARHomeComposeDemoViewProps {
  config?: Partial<HomeARHomeComposeDemoConfig>;
}

export function HomeARHomeComposeDemoView({ config: propsConfig }: HomeARHomeComposeDemoViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useHomeARHomeComposeDemoLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['HomeARDemoComposeTask'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="HomeAR" trait="HomeARHomeComposeDemo">
      {slotWriter['main'] === 'INIT' ? (<Split gap="xl" align="start" ratio="1:3"><HomeARDemoComposeEquationView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><HomeARDemoComposeTourView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Split>) : null}
    </TraitScopeProvider>
  );
}

export default HomeARHomeComposeDemoView;
